'use client';

import { Flex } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';
import { MdOutlineWork } from 'react-icons/md';

import { useJobIndustriesSelectorState } from '@/modules/shared/presentation/hooks/useJobIndustriesSelectorState';

import { CategorySelectDialog } from '../CategorySelectorDialog/CategorySelectorDialog';

type SelectorDialogProps = PropsWithChildren<{
	count?: number
}>;

export const JobIndustriesSelectorDialog = ({ children, count = 0 }: SelectorDialogProps) => {
	const {
		categories,
		collections,
		handleToggle,
		isLoading,
		selectedIds,
		setGroup,
	} = useJobIndustriesSelectorState();

	return (
		<CategorySelectDialog.Root>
			<CategorySelectDialog.Trigger asChild>
				{children}
			</CategorySelectDialog.Trigger>
			<CategorySelectDialog.Content>
				<CategorySelectDialog.CloseIcon />
				<CategorySelectDialog.Header icon={MdOutlineWork} title="Job Industries" />
				<CategorySelectDialog.Body as={Flex} direction="row">
					<CategorySelectDialog.SideBar
						groups={categories}
						onSelectGroup={setGroup}
					/>
					<CategorySelectDialog.Checklist
						collections={collections}
						isLoading={isLoading}
						onSelect={handleToggle}
						selectedIds={selectedIds}
					/>
				</CategorySelectDialog.Body>
				<CategorySelectDialog.Footer>
					<CategorySelectDialog.ActionButton count={count} label="Select" />
				</CategorySelectDialog.Footer>
			</CategorySelectDialog.Content>
		</CategorySelectDialog.Root>
	);
};
